import { render, staticRenderFns } from "./performancePersonComponent.vue?vue&type=template&id=6a7fa2b3&scoped=true&"
import script from "./performancePersonComponent.vue?vue&type=script&lang=js&"
export * from "./performancePersonComponent.vue?vue&type=script&lang=js&"
import style0 from "./performancePersonComponent.vue?vue&type=style&index=0&id=6a7fa2b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7fa2b3",
  null
  
)

export default component.exports